import { createMuiTheme, Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { GLOBAL_FONT_THEME } from 'theme/CommonTheme';

export const PrimarySwitch = withStyles({
    switchBase: {
        '&$checked': {
            color: '#009ad9 !important'
        },
        '&$checked + $track': {
            backgroundColor: '#009ad9  !important'
        }
    },
    checked: {},
    track: {}
})(Switch);

export const FILLED_INPUT_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiAutocomplete: {
            inputRoot: {
                alignItems: 'baseline !important'
            }
        },
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                padding: '25px 12px 6px !important',
                fontSize: '14px !important',
                color: '#282828 !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important'
            }
        }
    }
});

export const APP_BAR_THEME = createMuiTheme({
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: '#fff'
            },
            root: {
                marginTop: '50px',
                paddingLeft: '12px',
                minHeight: 64
            }
        },
        MuiTypography: {
            body1: {
                maxWidth: 300
            }
        }
    }
});

export const APP_BAR_THEME_ALT = createMuiTheme({
    overrides: {
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: '#fff'
            },
            root: {
                paddingLeft: '12px',
                minHeight: 64,
                paddingTop: '40px'
            }
        },
        MuiTypography: {
            body1: {
                maxWidth: 300
            }
        }
    }
});

export const FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME = createMuiTheme({
    overrides: {
        MuiAutocomplete: {
            inputRoot: {
                alignItems: 'baseline !important'
            },
            loading: {
                padding: '0px !important'
            },
            listbox: {
                maxHeight: '30vh !important'
            }
        },
        MuiFormControl: {
            root: {
                width: '100%',
                fontWeight: '500'
            }
        },
        MuiFilledInput: {
            root: {
                borderTopLeftRadius: '2px !important',
                borderTopRightRadius: '2px !important'
            },
            input: {
                padding: '7px 12px 6px 5px !important',
                fontSize: '14px !important',
                color: '#282828 !important'
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #00437b !important'
                }
            }
        },
        MuiFormHelperText: {
            contained: {
                margin: '8px 0 0'
            }
        },
        MuiFormLabel: {
            root: {
                fontWeight: 600,
                fontSize: '14px  !important'
            }
        }
    }
});

export const SPINNER_THEME = createMuiTheme({
    overrides: {
        MuiCircularProgress: {
            root: {
                padding: 10
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});
